// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import Vuefire from 'vuefire'
import VueClipboard from 'vue-clipboard2'
import colors from 'vuetify/es5/util/colors'
import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
import {
  ProgressDialog,
  Toast
} from 'luffanet-web-components'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

Vue.prototype.$fb = firebase.initializeApp({
  apiKey: 'AIzaSyCE68G4V8kXoQPmc76OTm0B8rJt6XxOeKw',
  authDomain: 'luffahub.firebaseapp.com',
  databaseURL: 'https://luffahub.firebaseio.com'
});
Vue.prototype.$auth = firebase.auth();
Vue.prototype.$db = firebase.database();

Vue.use(Vuetify, {
  theme: {
    primary: colors.teal.darken1,
    secondary: colors.lime.darken3,
    accent: colors.pink.lighten2
  }
})
Vue.use(Vuefire)
Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.use(VueCookie)
Vue.use(ProgressDialog)
Vue.use(Toast)

Vue.config.productionTip = false

router.beforeEach(function(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        if (to.name === 'Login') {
          next({
            path: to.query.redirect || '/'
          });
        } else {
          next();
        }
      } else {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      }
    });
  } else {
    next();
  }
});

const i18n = new VueI18n({
  locale: VueCookie.get('lang') || 'en',
  fallbackLocale: 'en',
  messages: {
    'en': require('./lang/en'),
    'zh': require('./lang/zh'),
    'jp': require('./lang/jp')
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js